// extracted by mini-css-extract-plugin
module.exports = {"title":"e_w-","hidden":"e_x-","showMore":"e_y-","features":"e_z-","featuresOpened":"e_A-","colorPositive":"e_B-","colorNegative":"e_C-","buttonOpen":"e_D-","hiddenDesktop":"e_E-"};